<template>
	<div class="home">
		<router-view></router-view>
		<Footer></Footer>
	</div>
</template>

<script>
	// import Header from "@/components/header.vue";
	import Footer from "@/components/footers.vue";
	export default {
		components: {
			// Header,
			Footer
		},
		mounted() {
			console.log('home', this.$route.meta.showMap);

		}
	}
</script>

<style lang="less">
	.home {
		// background-color: #FFFFFF;
	}
	table {
		width: 100%;
	}

	.el-table thead {
		font-size: 0.725rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333333;
		/* background: orange; */
	}

	.el-table tr {
		background: #f8f8f8 !important;
	}

	.el-table__header {
		width: 100% !important;
		/* background: orange; */
	}

	.el-table--border,
	.el-table--group {
		border: none;
	}

	.el-table--border::after,
	.el-table--group::after,
	.el-table::before {
		background: transparent;
	}

	.el-table th.el-table__cell {
		background: #f8f8f8 !important;
	}

	.el-table__body {
		font-size: 0.725rem !important;
		font-family: Microsoft YaHei !important;
		font-weight: 400 !important;
		color: #666666 !important;
		width: 100% !important;
	}

	.el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 3px solid #fff;
	}

	.el-table--border .el-table__cell,
	.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
		border-right: 3px solid #fff;
	}
</style>
